import { OrderFormCategoryDTO } from 'support/types/dtos';

const createProduct = (
  id: string,
  name: string,
  description: string,
  price: number,
  articleNumber: string,
  attributes: Array<{ name: string; value: string }>,
) => ({
  id,
  partner_id: 'mock-partner-id',
  name,
  description,
  is_orderable: true,
  unit_price: price,
  discounted_unit_price: price,
  currency: 'EUR',
  identifiers: [{ domain: 'SENDER_INTERNAL' as const, value: articleNumber }],
  attributes: attributes.map((attr, index) => ({
    id: `attr-${id}-${index}`,
    name: attr.name,
    value: attr.value,
  })),
});

export const mockOrderFormCategories: Array<OrderFormCategoryDTO> = [
  {
    name: 'Fresh Breads',
    products: [
      createProduct(
        'bread-001',
        'Artisan Sourdough',
        'Traditional sourdough with crispy crust and soft interior',
        4.5,
        'BR-SOUR-001',
        [
          { name: 'Weight', value: '500g' },
          { name: 'Shelf Life', value: '3 days' },
        ],
      ),
      createProduct(
        'bread-002',
        'Whole Wheat Loaf',
        'Nutritious whole wheat bread with seeds and grains',
        3.8,
        'BR-WHEAT-002',
        [
          { name: 'Weight', value: '400g' },
          { name: 'Organic', value: 'Yes' },
        ],
      ),
      createProduct('bread-003', 'French Baguette', 'Classic French baguette with golden crust', 2.2, 'BR-BAG-003', [
        { name: 'Length', value: '60cm' },
        { name: 'Best served', value: 'Same day' },
      ]),
      createProduct('bread-004', 'Rye Bread', 'Dense German-style rye bread with caraway seeds', 5.2, 'BR-RYE-004', [
        { name: 'Weight', value: '750g' },
        { name: 'Traditional', value: 'German recipe' },
      ]),
      createProduct('bread-005', 'Ciabatta', 'Italian bread with airy texture and olive oil', 3.6, 'BR-CIA-005', [
        { name: 'Origin', value: 'Italy' },
        { name: 'Weight', value: '300g' },
      ]),
    ],
  },
  {
    name: 'Premium Sausages',
    products: [
      createProduct(
        'sausage-001',
        'Bratwurst',
        'Traditional German bratwurst with natural casing',
        8.9,
        'SAU-BRAT-001',
        [
          { name: 'Weight', value: '120g each' },
          { name: 'Pack size', value: '4 pieces' },
          { name: 'Meat content', value: '85%' },
        ],
      ),
      createProduct(
        'sausage-002',
        'Italian Sausage',
        'Spicy Italian sausage with fennel and red pepper',
        9.5,
        'SAU-ITAL-002',
        [
          { name: 'Spice level', value: 'Medium' },
          { name: 'Weight', value: '150g each' },
          { name: 'Pack size', value: '3 pieces' },
        ],
      ),
      createProduct('sausage-003', 'Chorizo', 'Spanish chorizo with paprika and garlic', 12.8, 'SAU-CHOR-003', [
        { name: 'Origin', value: 'Spain' },
        { name: 'Weight', value: '200g' },
        { name: 'Cured', value: '30 days' },
      ]),
      createProduct('sausage-004', 'Weisswurst', 'Bavarian white sausage with veal and pork', 7.4, 'SAU-WEISS-004', [
        { name: 'Traditional', value: 'Bavarian' },
        { name: 'Weight', value: '100g each' },
        { name: 'Pack size', value: '6 pieces' },
      ]),
    ],
  },
  {
    name: 'Deli Meats',
    products: [
      createProduct(
        'deli-001',
        'Black Forest Ham',
        'Premium smoked ham from the Black Forest region',
        15.6,
        'DELI-HAM-001',
        [
          { name: 'Origin', value: 'Black Forest, Germany' },
          { name: 'Weight', value: '200g sliced' },
          { name: 'Smoked', value: 'Traditional method' },
        ],
      ),
      createProduct('deli-002', 'Turkey Breast', 'Lean roasted turkey breast, thinly sliced', 11.2, 'DELI-TURK-002', [
        { name: 'Fat content', value: 'Low' },
        { name: 'Weight', value: '150g sliced' },
        { name: 'Protein', value: 'High' },
      ]),
      createProduct('deli-003', 'Salami Milano', 'Italian dry-cured salami with fine texture', 18.9, 'DELI-SAL-003', [
        { name: 'Origin', value: 'Milano, Italy' },
        { name: 'Aging', value: '60 days' },
        { name: 'Weight', value: '250g sliced' },
      ]),
      createProduct(
        'deli-004',
        'Prosciutto di Parma',
        'Authentic Italian prosciutto, aged 24 months',
        24.5,
        'DELI-PROS-004',
        [
          { name: 'DOP certified', value: 'Yes' },
          { name: 'Aging', value: '24 months' },
          { name: 'Weight', value: '100g sliced' },
        ],
      ),
    ],
  },
];
